import { useDispatch } from 'react-redux';
import { Dispatch, useEffect } from 'react';

import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';
import {
  dictionariesKnmKindsItemGet,
  dictionariesKnoOrganizationsItemGet,
  dictionariesKnoSupervisionGet,
  dictionariesSupervisionTypesItemGet,
} from '../../../CorePackage/DictionariesModule/actions/dictionariesActions';
import { KnmTypeCodesEnum } from '../../../APIPackage/CatalogsModule/enums/KnmTypeCodesEnum';
import {
  catalogErknmKnmConditionsGet,
  catalogKnmTypes248Get,
} from '../../../CorePackage/CatalogsModule/actions/catalogsActions';
import { accountOrganizationsWithDistrictGet } from '../../../CorePackage/AccountModule/actions/accountActions';

export const useCreateErknmModalDictionaries = (values: IKnmForm) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const { knoOrganizationErknm, kindControl, typeErknm, kindKnm, reasonsErknm } = values;
  const isTypeErknmPP = typeErknm?.value === KnmTypeCodesEnum.PP;
  const knoOrganizationId = knoOrganizationErknm?.value.dictVersionId;
  const supervisionTypeId = kindControl?.value.dictVersionId;
  const typeErknmCode = typeErknm?.value;
  const kindKnmId = kindKnm?.value.dictVersionId;
  const reasonUuid =
    reasonsErknm?.map(x => x.reason?.ervkUuid)?.find(uuid => uuid) ||
    reasonsErknm?.map(x => x.type?.ervkUuid)?.find(uuid => uuid);

  useEffect(() => {
    dispatch(dictionariesKnoOrganizationsItemGet());
    dispatch(accountOrganizationsWithDistrictGet());
  }, []);

  useEffect(() => {
    if (knoOrganizationId && supervisionTypeId) {
      dispatch(dictionariesKnoSupervisionGet(knoOrganizationId, supervisionTypeId));
    }
  }, [knoOrganizationId, supervisionTypeId]);

  useEffect(() => {
    if (knoOrganizationId) {
      dispatch(dictionariesSupervisionTypesItemGet([knoOrganizationId], isTypeErknmPP));
    }
  }, [knoOrganizationId, isTypeErknmPP]);

  useEffect(() => {
    if (knoOrganizationId && supervisionTypeId) {
      dispatch(catalogKnmTypes248Get({ knoVersionId: knoOrganizationId, supervisionVersionId: supervisionTypeId }));
    }
  }, [knoOrganizationId, supervisionTypeId]);

  useEffect(() => {
    if (knoOrganizationId && supervisionTypeId && typeErknmCode) {
      dispatch(catalogErknmKnmConditionsGet(knoOrganizationId, supervisionTypeId, typeErknmCode, kindKnmId));
    }
  }, [knoOrganizationId, supervisionTypeId, typeErknmCode, kindKnmId]);

  useEffect(() => {
    if (knoOrganizationId && supervisionTypeId && reasonUuid) {
      dispatch(
        dictionariesKnmKindsItemGet({
          knoVersionId: knoOrganizationId,
          supervisionVersionId: supervisionTypeId,
          conditionUuid: reasonUuid,
        }),
      );
    }
  }, [knoOrganizationId, supervisionTypeId, reasonsErknm]);
};
